import * as React from 'react'
import ProposalsTable from '../Proposals/ProposalsTable'

interface IProps {
  contactId: string
}

const ContactProposals = (props: IProps) => {
  const { contactId } = props

  return (
    // @ts-ignore
    <ProposalsTable
      contactId={contactId}
      primaryActionEnabled
    />
  )
}

export default ContactProposals